import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'views/FormComponents';
import { Row, Columns } from 'views/Grid';

class PrefixedInput extends React.Component {
  render () {
    const { prefix, ...others } = this.props;
    return (
      <Row className="collapse prefix-radius">
        <Columns className="small-2">
          <span className="prefix">{prefix}</span>
        </Columns>
        <Columns className="small-10">
          {
            others.type === 'number'
            ? <InputNumber {...others} />
            : <input {...others} />
          }
        </Columns>
      </Row>
    );
  }
}

PrefixedInput.propTypes = {
  prefix: PropTypes.any.isRequired,
};

export default PrefixedInput;



// WEBPACK FOOTER //
// ./src/common/views/form/PrefixedInput.js